import * as accountActions from 'redux/actions/account.actions'
import * as actions from 'redux/actions/list.actions'

const initialState = {
  lists: [],
  list: null
}

const listReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getListsSuccess.type:
      return {
        ...state,
        lists: payload.lists
      }
    case actions.getListSuccess.type:
      return {
        ...state,
        list: payload.list
      }
    case actions.clearList.type:
      return {
        ...state,
        list: null
      }
    case accountActions.getAccountDataFailure.type:
      return initialState
    default:
      return state
  }
}

export default listReducer
